import { MdClose } from 'react-icons/md'
import './modal.css'

const Modal = ({videos, isModal, isSetModal}) => {

      if(!isModal) return;

      const closeModal = () => {
            isSetModal(false)
      }

      const url = `https://www.youtube.com/embed/${videos[0].id_video}`;

      return (
            <div className={isModal ? "modal_content show" : "modal_content"}>
                  <button className="close_modal" onClick={() => closeModal()}><MdClose /></button>
                  <div className="video_content">
                        <div className="video_box">
                              <iframe width="100%" height="100%" src={url} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                        </div>
                  </div>
            </div>
      )
}

export default Modal
